import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  title?: ReactNode;
  action?: ReactNode;
}

/** Card padrão do dashboard (dark): border ink-800 + bg ink-900. */
export function Card({ children, className, title, action }: CardProps) {
  return (
    <section className={'border-ink-800 bg-ink-900 rounded-xl border ' + (className ?? '')}>
      {(title || action) && (
        <header className="border-ink-800 flex items-center justify-between border-b px-5 py-3.5">
          {title && <h3 className="text-ink-100 text-sm font-semibold">{title}</h3>}
          {action}
        </header>
      )}
      {children}
    </section>
  );
}
